import { Link } from 'react-router-dom';
import { ArrowUpRight, Github, Twitter, Instagram, Linkedin } from 'lucide-react';
import './Footer.css';

const SOCIALS = [
  { name: 'LinkedIn', icon: Linkedin, url: 'https://www.linkedin.com/in/t%C3%A6kni-technology-studio/' },
  { name: 'Twitter', icon: Twitter, url: 'https://x.com/Taekni_io' },
  { name: 'Instagram', icon: Instagram, url: 'https://www.instagram.com/taekni.io/?igsh=eHZscmp0YWkxZ3Fi#' },
  { name: 'GitHub', icon: Github, url: 'https://github.com/taekni0505' }
];

const LINKS = [
  { name: 'Home', path: '/' },
  { name: 'About', path: '/about' },
  { name: 'Services', path: '/services' },
  { name: 'Contact', path: '/contact' }
];

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="stacked-footer-shell">
      <footer className="stacked-footer-card">
        <div className="stacked-footer-main">
          <div>
            <h2 className="stacked-footer-heading">Let's craft.</h2>
            <p className="stacked-footer-tagline">
              We build digital experiences that stick. No fluff, just results.
            </p>
          </div>

          <div className="stacked-footer-links-grid">
            <div>
              <h4 className="stacked-footer-subtitle">Menu</h4>
              <ul className="stacked-footer-list">
                {LINKS.map((link) => (
                  <li key={link.name}>
                    <Link to={link.path}>{link.name}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="stacked-footer-subtitle">Social</h4>
              <ul className="stacked-footer-list">
                {SOCIALS.map((social) => {
                  const Icon = social.icon;
                  return (
                    <li key={social.name}>
                      <a href={social.url} target="_blank" rel="noopener noreferrer">
                        <Icon size={18} />
                        <span>{social.name}</span>
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>

        <div className="stacked-footer-bottom">
          <h1 className="stacked-footer-watermark">TÆKNI</h1>
          <button
            type="button"
            className="stacked-footer-fab"
            onClick={scrollToTop}
            aria-label="Back to top"
          >
            <ArrowUpRight size={24} color="white" />
          </button>
        </div>
      </footer>
    </div>
  );
};

export default Footer;